import { isAIUsageLimitPayload } from '@polybank/shared';
import { aiUpgradeActions } from '@/state/ai-upgrade-state';
import { toast } from 'sonner';

/**
 * Generic API error handler.
 * Dispatches known structured errors to the appropriate UI action.
 * New error types can be added here as the application grows.
 */
export function handleApiError(error: unknown, fallbackMessage: string): void {
  if (isAIUsageLimitPayload(error)) {
    aiUpgradeActions.show(error.feature, error.plan);
    return;
  }
  toast.error(fallbackMessage);
}

/**
 * Same but for SSE 'error' event data payloads.
 * Returns true if the error was recognized and handled (caller should skip setting error state).
 */
export function handleSseError(data: unknown): boolean {
  if (isAIUsageLimitPayload(data)) {
    aiUpgradeActions.show(data.feature, data.plan);
    return true;
  }
  return false;
}
